export default __webpack_public_path__ + "static/media/driving.131b6f32.png";